const gameEnd = data_handler.gameEnd;

class Timer {
	timeDistance = () => {
		const now = Math.floor(new Date().getTime() / 1000);
		const distance = gameEnd - now;

		return distance;
	};
}

export default new Timer();
